import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import MainLogo from '../marketLogo.jpg';
import ButtonBase from '@material-ui/core/ButtonBase';
import {
  BrowserRouter as Router, Route, NavLink, Switch, Link
} from 'react-router-dom';

import Modal from '@material-ui/core/Modal';

import { Image } from 'react-bootstrap';

import {
  isMobileOnly, isIE, isEdge, isSafari
} from "react-device-detect";

import roundIcon from '../roundIcon.png';

import moment from 'moment';

import * as firebase from 'firebase';

let QRCode = require('qrcode.react');

class GiftCard extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loadingStart: false,
      isLoading: this.props.isLoading,
      userInfo: this.props.userInfo,
      giftCardId: this.props.match.params.id,
      giftCard: null,
      showQRImageModal: false,
      isUsedGiftCard: false
    }
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ loadingStart: true })
    }, 100)
  }

  componentDidMount() {
    firebase.database().ref(`giftCards/${this.state.giftCardId}`).on('value', (snapshot) => {
      if (snapshot.val()) {
        this.setState({ giftCard: snapshot.val() })
        if (this.onGetRemainAmount(snapshot.val()) <= 0) {
          this.setState({ showQRImageModal: false })
          setTimeout(() => {
            this.setState({ isUsedGiftCard: true })
          }, 10)
        }
      } else {
        this.setState({ giftCard: false })
      }
    })
  }

  componentWillUnmount() {
    firebase.database().ref(`giftCards/${this.state.giftCardId}`).off('value')
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isLoading === false) {
      this.setState({ userInfo: nextProps.userInfo, isLoading: false });
    } else {
      this.setState({ isLoading: true });
    }
  }

  onChangeCurrencyFormat(value) {
    return value.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  onStringNumberToDate(str) {
    let stringNumber = str.toString()
    return stringNumber.substring(0, 4) + "년 " + stringNumber.substring(4, 6) + "월 " + stringNumber.substring(6, 8) + '일'
  }

  // 상품권의 남은 금액을 계산한다. (잔액 분할 사용 지원)
  onGetRemainAmount(giftCard) {
    if (typeof giftCard.remainAmount === "number") {
      return giftCard.remainAmount
    }
    return giftCard.usedAt ? 0 : giftCard.amount
  }

  render() {
    if (this.state.isLoading || this.state.giftCard === null) {
      return (
        <div className={this.state.loadingStart ? "center-div direction-column-div loading-animation1" : "center-div direction-column-div loading-animation2"}>
          <Image src={roundIcon} style={{ width: 60, height: 60 }} fluid />
        </div>
      )
    }
    if (this.state.giftCard === false) {
      return <Grid container className="auto-width-100" justify="center"><div style={{ marginTop: 100 }}><span>상품권이 존재하지 않습니다.</span></div></Grid>
    }

    let giftCard = this.state.giftCard

    // 인쇄만 되고 아직 매장에서 등록되지 않은 실물 상품권.
    // 등록되면 이 페이지가 실시간으로 갱신되어 아래의 일반 상품권 화면으로 바뀐다.
    if (giftCard.type === 'physical' && !giftCard.registered) {
      return (
        <Grid container className="auto-width-100 no-selection" justify="center" style={{ paddingBottom: 60 }}>
          <div className="auto-width-100" style={{ marginLeft: 10 }}>
            <ButtonBase
              to={`/home`}
              component={Link}
              style={{ color: "black", textDecoration: 'none' }}
              onClick={() => {
                if (this.props.navIndexChanges) {
                  this.props.navIndexChanges(0)
                }
                setTimeout(() => {
                  if (this.props.routeChanges) {
                    this.props.routeChanges()
                  }
                  window.scrollTo({ top: 0, left: 0 })
                }, 10)
              }}
            >
              <Image className="logo-style" src={MainLogo} />
            </ButtonBase>
          </div>
          <Grid container justify="center">
            <div
              style={{
                width: 320,
                maxWidth: '90%',
                marginTop: 25,
                borderRadius: 18,
                padding: '26px 24px',
                background: 'linear-gradient(135deg, #5f6b6a 0%, #3a4443 100%)',
                boxShadow: '0 10px 24px rgba(58, 68, 67, 0.35)',
              }}
            >
              <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', letterSpacing: 1, display: 'block' }}>GIFT CARD</span>
              <span style={{ fontSize: 16, color: 'white', fontWeight: 'bold', marginTop: 4, display: 'block' }}>
                {giftCard.name || '위드어나드 상품권'}
              </span>
              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 22, display: 'block' }}>상품권 금액</span>
              <span style={{ fontSize: 34, color: 'white', fontWeight: 'bold', lineHeight: 1.1, display: 'block' }}>
                {this.onChangeCurrencyFormat(giftCard.amount)}원
              </span>
              <span style={{ fontSize: 13, color: 'white', fontWeight: 'bold', marginTop: 18, display: 'block' }}>
                아직 등록되지 않은 상품권입니다
              </span>
            </div>
          </Grid>
          <Grid container justify="center">
            <div className="direction-column-div auto-width-90" style={{ marginTop: 22 }}>
              <span style={{ fontSize: 14, fontWeight: 'bold', marginLeft: 8 }}>이용 안내</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 매장에서 카드의 QR을 등록하면 등록일부터 6개월간 사용하실 수 있습니다.</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 등록 후에는 이 페이지에서 남은 금액과 사용 내역을 확인하실 수 있습니다.</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 잔액 내에서 여러 번 나누어 사용하실 수 있습니다.</span>
            </div>
          </Grid>
        </Grid>
      )
    }

    let remainAmount = this.onGetRemainAmount(giftCard)
    let isUsedUp = remainAmount <= 0
    let usagePercent = giftCard.amount > 0 ? Math.max(0, Math.min(100, Math.round((remainAmount / giftCard.amount) * 100))) : 0
    let usageHistory = giftCard.usageHistory ? Object.values(giftCard.usageHistory) : []

    return (
      <Grid container className="auto-width-100 no-selection" justify="center" style={{ paddingBottom: 60 }}>
        <Grid container className="auto-width-100" justify="center" style={isUsedUp ? { pointerEvents: "none", opacity: "0.25" } : {}}>
          <div className="auto-width-100" style={{ marginLeft: 10 }}>
            <ButtonBase
              to={`/home`}
              component={Link}
              style={{ color: "black", textDecoration: 'none' }}
              onClick={() => {
                if (this.props.navIndexChanges) {
                  this.props.navIndexChanges(0)
                }
                setTimeout(() => {
                  if (this.props.routeChanges) {
                    this.props.routeChanges()
                  }
                  window.scrollTo({ top: 0, left: 0 })
                }, 10)
              }}
            >
              <Image className="logo-style" src={MainLogo} />
            </ButtonBase>
          </div>

          {/* 상품권 카드 */}
          <Grid container justify="center">
            <div
              style={{
                width: 320,
                maxWidth: '90%',
                marginTop: 25,
                borderRadius: 18,
                padding: '26px 24px',
                background: 'linear-gradient(135deg, #00615c 0%, #0a3f3c 100%)',
                boxShadow: '0 10px 24px rgba(0, 97, 92, 0.35)',
                position: 'relative',
                overflow: 'hidden'
              }}
            >
              <div className="direction-row-div" style={{ justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div className="direction-column-div">
                  <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)', letterSpacing: 1 }}>GIFT CARD</span>
                  <span style={{ fontSize: 16, color: 'white', fontWeight: 'bold', marginTop: 4 }}>
                    {giftCard.name || '위드어나드 상품권'}
                  </span>
                </div>
                <div
                  onClick={() => { this.setState({ showQRImageModal: true }) }}
                  style={{ background: 'white', padding: 6, borderRadius: 10, cursor: 'pointer' }}
                >
                  <QRCode value={this.state.giftCardId} renderAs={'svg'} level={'H'} size={62} bgColor={'white'} includeMargin={false} fgColor='#00615c' />
                </div>
              </div>

              <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)', marginTop: 22, display: 'block' }}>남은 금액</span>
              <span style={{ fontSize: 34, color: 'white', fontWeight: 'bold', lineHeight: 1.1 }}>
                {this.onChangeCurrencyFormat(remainAmount)}원
              </span>

              {/* 잔액 바 */}
              <div style={{ background: 'rgba(255,255,255,0.2)', borderRadius: 6, height: 6, marginTop: 14, overflow: 'hidden' }}>
                <div style={{ background: 'white', height: 6, width: `${usagePercent}%`, borderRadius: 6 }} />
              </div>
              <div className="direction-row-div" style={{ justifyContent: 'space-between', marginTop: 8 }}>
                <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>
                  충전 금액 {this.onChangeCurrencyFormat(giftCard.amount)}원
                </span>
                <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.7)' }}>withanod.com</span>
              </div>
            </div>
          </Grid>

          <span style={{ fontSize: 12, color: 'black', marginTop: 16 }}>
            유효기간: {this.onStringNumberToDate(moment(giftCard.issuedAt + (giftCard.expireDate || 365) * 24 * 1000 * 60 * 60).format('YYYYMMDD').toString())}까지
          </span>

          {/* 사용 내역 */}
          {usageHistory.length > 0 &&
            <Grid container justify="center">
              <div className="direction-column-div auto-width-90" style={{ marginTop: 18, padding: 14, backgroundColor: '#f7f7f7', borderRadius: 10 }}>
                <span style={{ fontSize: 13, fontWeight: 'bold', marginBottom: 4 }}>사용 내역</span>
                {usageHistory
                  .sort((a, b) => b.usedAt - a.usedAt)
                  .map((history, index) => {
                    return (
                      <div key={index} className="direction-row-div" style={{ justifyContent: 'space-between', marginTop: 8 }}>
                        <span style={{ fontSize: 12, color: 'gray' }}>
                          {this.onStringNumberToDate(moment(history.usedAt).format('YYYYMMDD').toString())}
                        </span>
                        <span style={{ fontSize: 12, color: '#ff4040', fontWeight: 'bold' }}>
                          -{this.onChangeCurrencyFormat(history.amount)}원
                        </span>
                      </div>
                    )
                  })}
              </div>
            </Grid>
          }

          {/* 안내 */}
          <Grid container justify="center">
            <div className="direction-column-div auto-width-90" style={{ marginTop: 22 }}>
              <span style={{ fontSize: 14, fontWeight: 'bold', marginLeft: 8 }}>이용 안내</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 오프라인 매장에서 현금처럼 사용 가능한 상품권입니다.</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 잔액 내에서 여러 번 나누어 사용하실 수 있습니다.</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 남은 잔액은 다음 방문 시에도 사용 가능합니다.</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 유효기간 내에 사용해 주시기 바랍니다.</span>
              <span style={{ fontSize: 12, marginTop: 6, marginLeft: 8 }}>- 현금 교환 및 잔액 환불은 관련 법령에 따라 처리됩니다.</span>
            </div>
          </Grid>
        </Grid>

        {isUsedUp &&
          <div>
            {!this.state.isUsedGiftCard
              ? <div className="center-spinner direction-column-div align-center coupon-used-big">
                <span style={{ fontSize: 22, color: '#ff4040', fontWeight: 'bold' }}>사용완료</span>
              </div>
              : <div className="center-spinner direction-column-div align-center coupon-used-small">
                <span style={{ fontSize: 22, color: '#ff4040', fontWeight: 'bold' }}>사용완료</span>
              </div>
            }
          </div>
        }

        <Modal
          open={this.state.showQRImageModal}
          onClose={() => this.setState({ showQRImageModal: false })}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          BackdropProps={{ style: { backgroundColor: 'rgba(0,0,0,0.8)' } }}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <div className="remove-item-modal">
            <QRCode value={this.state.giftCardId} renderAs={'svg'} level={'H'} size={220} bgColor={'white'} includeMargin={true} fgColor='#00615c' />
          </div>
        </Modal>
      </Grid>
    )
  }
}

export default GiftCard;
